module.exports = __webpack_public_path__ + "static/media/donttouch.255c5aea.jpg";